import Countdown from "@/components/Countdown";
import AddToCalendarButton from "@/components/AddToCalendarButton";
import { SCRIPT_IMG, ScriptImage } from "@/components/ScriptImage";

export default function WelcomePanel() {
  return (
    <div
      data-testid="panel-block-welcome"
      className="max-w-[680px] mx-auto px-2 md:px-0 pb-16"
      style={{ fontFamily: "'Cormorant Garamond', serif" }}
    >
      <div className="text-center pt-2">
        <ScriptImage src={SCRIPT_IMG.welcome} alt="Welcome" />
        <p className="mt-3 text-[10px] md:text-[11px] uppercase tracking-[0.36em] text-[#76232F]/80">
          October 30, 2026
        </p>
        <div className="mt-10">
          <Countdown />
        </div>
        <AddToCalendarButton />

        <div className="mt-12 max-w-[520px] mx-auto text-left space-y-4 text-[15px] md:text-base leading-[1.7] text-[#2C1A1D]/85">
          <p>
            Welcome to the Baker&rsquo;s Wedding &mdash; we are so excited to
            celebrate with you all!
            <br />
            Please navigate the website for all info needed to enjoy your day
            with us.
          </p>
          <p className="italic text-[#2C1A1D]/70 text-[14px] md:text-[15px]">
            For additional enquiries not covered in the FAQs, please reach
            out to Scott or Isabelle directly.
          </p>
        </div>
      </div>
    </div>
  );
}
